import { Language } from 'ha/i18n';

import { ContentfulSupportedLangs } from '../../Hermes/constants';

export default (lang: Language) => ContentfulSupportedLangs.includes(lang);
